import { useState } from "react";
// import Reactportal from "../../../../../../Components/SpComponents/Reactportal/Reactportal";
import FormattedTime from "../../../../../../Components/BookingComponents/FormattedTime/FormattedTime";
import Reactportal from "../../../../../../Components/Reactportal/Reactportal";
import LoadDetails from "../../../../../LoadEntry/LoadDetails";
import "./DetailsBox.scss";

function DetailsBox({
  from,
  to,
  vehicleNo,
  driverName,
  driverNo,
  vehicalDetails,
  materialCategory,
  exactContent,
  vehicle_Category,
  vehicle_Type,
  totalWeight,
  loadId,
  LoadID,
  Notes,
  BidNote,
  GPS_Link,
  LR_No,
  Eway_Bill_Number,
  Vehicle_Capacity,
  Reporting_Time,
  // RC_Data,
  // DL_Photo,
  loadData,
  Sim_Tracking_Link,
  Sp_Account_Name,

  SP_Mobile_Number,
  LP_Business_Name,
  LP_Mobile_Number,
}) {
  const [loadDetailsModal, setLoadDetailsModal] = useState(false);

  return (
    <>
      {/* <div className="detailsBoxEachBox">
        <div className="heading">
          <p className="headingText">Details</p>
        </div>
        <div className="belowbox">
          <p className="contentText">
            {from} to {to}
          </p>
          <p className="contentText">
            <GetVehicleNo vehicleNoId={vehicleNo} />
          </p>
          <p className="contentText">
            {driverName} - {driverNo}
          </p>
          <p className="contentText">{vehicalDetails}</p>
          <p className="contentText">
            {materialCategory}({exactContent}) - {totalWeight}MT
          </p>
          <p className="contentText loadIdLink">
            Load Id :{" "}
            <span
            // className="loadIdNumber"
            // onClick={() => setLoadDetailsModal(!loadDetailsModal)}
            >
              {loadId}
            </span>
          </p>
        </div>
      </div> */}

      <div className="detailsBoxEachBox">
        <div className="heading">
          <p className="headingText">Details</p>
        </div>
        <div className="belowbox">
          <p className="contentText">
            <span>{driverName}</span> - {driverNo}
          </p>
          <p className="contentText">
            <span>Vehicle Type</span> - {vehicle_Type}
          </p>
          <p className="contentText">
            <span>Vehicle Category</span>- {vehicle_Category}
          </p>
          <p className="contentText">
            <span>Reporting Time</span>
            - <FormattedTime time={Reporting_Time} />
          </p>

          {/* <p className="contentText">{vehicalDetails}</p> */}
          {LR_No && <p className="contentText">LR_No - {LR_No}</p>}
          {Eway_Bill_Number && <p className="contentText">Eway Bill Number - {Eway_Bill_Number}</p>}
          <p className="contentText">
            {materialCategory}({exactContent}) - {Vehicle_Capacity}MT
          </p>
          <p className="contentText loadIdLink">
            <span>Load Id</span> :{" "}
            <span className="loadIdNumber" onClick={() => setLoadDetailsModal(!loadDetailsModal)}>
              {loadId}
            </span>
          </p>
          <p className="contentText">
            <span>LP Business Name</span>: {LP_Business_Name}
          </p>
          <p className="contentText">
            <span>LP Mobile Number</span> : {LP_Mobile_Number}
          </p>
          <p className="contentText">
            <span>SP Business Name</span>: {Sp_Account_Name}
          </p>

          <p className="contentText">
            <span>SP Mobile Number</span>: {LP_Mobile_Number}
          </p>
          {/* {GPS_Link && (
            <p className="contentText loadIdLink">
              Track live location :{" "}
              <span className="loadIdNumber" onClick={handleVisitGPS}>
                GPS Track
              </span>
            </p> 
          )} */}
          {/* {Sim_Tracking_Link && (
            <p className="contentText loadIdLink">
              Track live location :{" "}
              <span className="loadIdNumber" onClick={handleVisitSIM}>
                SIM Track
              </span>
            </p>
          )} */}
        </div>
        <Reactportal
          open={loadDetailsModal}
          onClose={() => setLoadDetailsModal(false)}
          TypeOfPortal={`Load Id : ${loadId}`}
        >
          <div className="mainResultDetailsdiv">
            <LoadDetails LoadId={LoadID} Type={"ResultLP"} />
          </div>
        </Reactportal>
      </div>
    </>
  );
}

export default DetailsBox;
